/**
 * @file
 * A JavaScript file containing the main menu functionality (small/large screen)
 *
 */

/**
 * Enter Espoo JS.
 */
(function (Drupal, $) {
  Drupal.behaviors.mainMenu = {
    attach: function (context) {
      if (context !== document) {
        return;
      }

      init();
    }
  };

  function init() {
    let body = $(document);
    let menu = $('.main-nav-container');
    let button = menu.find('#ee-burger');
    let expanded = button.attr('aria-expanded');
    let mobileWidth = 1110;

    body.on("keydown", function(e) {
      escHideNav(button, e);
    });

    handleMenuKeyPress(menu, button, expanded);

    $(window).resize(function() {
      if ($(window).width() <= mobileWidth) {
        if (menu.hasClass('desktop-initialized')) {
          menu.removeClass("desktop-initialized");
        }
        if (!menu.hasClass('mobile-initialized')) {
          mobileNavInit(menu);
        }
      }
      else {
        if (menu.hasClass('mobile-initialized')) {
          menu.removeClass("mobile-initialized");
        }
        if (!menu.hasClass('desktop-initialized')) {
          desktopNavInit(menu);
        }
      }
    }).trigger("resize");
  }

  function handleMenuKeyPress(menu, button, expanded) {
    button.on("click", function(e) {
      e.preventDefault();
      toggleMenu(button, expanded, e);
    });

    button.on("keydown", function(e) {
      handleKeyboardPress(button, menu, e);
    });
  }

  function toggleMenu(button, expanded, e) {
    // Toggle SVGs.
    $(e.currentTarget).find('svg.burger-open').toggleClass('mobile-nav-hidden');
    $(e.currentTarget).find('svg.burger-close').toggleClass('mobile-nav-hidden');

    // Toggle aria-expanded attribute.
    triggerAria(button);

    // Toggle menu visibility.
    let menu = $('#main-nav');
    $(menu).toggleClass('mobile-nav-hidden');
  }


  function handleKeyboardPress(button, menu, e) {
    let expanded = button.attr('aria-expanded');

    // Check if space is triggered on menu item.
    switch (e.keyCode) {
      case 32:
        e.preventDefault();
        toggleMenu(button, expanded, e);
        break;
      case 27:
        e.preventDefault();
        escHideNav(button, e);
        break;
    }
  }

  function escHideNav(button, e) {
    let expanded = button.attr('aria-expanded');

    if (e.keyCode === 27 && expanded === 'true') {
      toggleMenu(button, expanded, e);
      button.focus();
    }
  }

  function mobileNavInit(menu) {
    let allExpandableNavItems = $(menu).find('.main-menu__item--with-sub');

    addListenersToEach(allExpandableNavItems);
    menu.addClass('mobile-initialized');
  }

  function addListenersToEach(navItems) {
    navItems.map(function(k, val) {
      let wrapper = $(val);
      let button = wrapper.first().find('.expand-sub')[0];

      wrapper.on("click", function(e) {
        if (button === e.target) {
          triggerSubMenu(wrapper, button);
        }
      });

      wrapper.on("keydown", function(e) {
        // Check if space is triggered on menu item.
        if (e.keyCode === 32) {
          e.preventDefault();
          triggerSubMenu(wrapper, button);
        }
      });
    });
  }

  // Toggle aria-expanded attribute.
  function triggerAria(item) {
    $(item).attr('aria-expanded', function (i, aria) {
      return aria === 'true' ? 'false' : 'true';
    });
  }

  function triggerSubMenu(wrapper, button) {
    triggerAria(button);
    let menu = wrapper.first().find('.main-menu--sub')[0];
    $(menu).toggleClass('is-active');
  }

  function desktopNavInit(menu) {
    let allExpandableNavItems = $(menu).find('.main-menu__item--with-sub:not(.main-menu__item--sub-1)');

    allExpandableNavItems.map(function(k, val) {
      let wrapper = $(val);
      let button = wrapper.find('.expand-sub.sub-1')[0];
      let menu = wrapper.find('.main-menu--sub')[0];

      wrapper.on("keydown", function(e) {
        // Check if space is triggered on menu item.
        if (e.keyCode === 32) {
          e.preventDefault();

          if (e.target.href) {
            e.target.click();
          }

          triggerAria(button);
          $(menu).toggleClass('is-active');
        }
        if (e.keyCode === 9) {
          $('body').focusin(function(e) {
            if (!$(e.target).parent().is('ul.is-active li')) {
              $(menu).removeClass('is-active');
              $(button).attr('aria-expanded', 'false');
            }
          });
        }
      });
    });

    menu.addClass('desktop-initialized');
  }

})(Drupal, jQuery);
